(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8378],{

/***/ 79877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overseas-education-fair/[slug]",
      function () {
        return __webpack_require__(92790);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46412);
/* harmony import */ var _components_OverseasEdutionFair_LandingPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80487);




const EducationFair = (props)=>{
    // if (!props.pageData || props.pageData.length === 0 || props.pageData[0].categoryType !== 'overseas_education_fair') {
    //   return <ErrorComponent />
    // }
    if (!Array.isArray(props.pageData) || props.pageData.length === 0 || props.pageData[0]?.categoryType !== "overseas_education_fair") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_OverseasEdutionFair_LandingPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...props
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (EducationFair);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,5655,992,4459,487,9774,2888,179], function() { return __webpack_exec__(79877); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);